import { HIDE_LOGIN_MODAL } from 'actions';

export function hideLoginModal() {
  return { type: HIDE_LOGIN_MODAL };
}
